import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createPortal } from 'react-dom';
// Cursor tooltip naming the data source under the pointer. Rendered at the host
// level (not inside the collapsible control) so hovering still identifies a
// region when the Map panel is collapsed. Portaled to body so it's never clipped.
const CoverageHoverTooltipComponent = ({ hover }) => {
    if (!hover)
        return null;
    return createPortal(_jsx("div", { className: "fixed z-[100] pointer-events-none px-2 py-1 rounded-full text-[11px] shadow-lg", style: {
            left: hover.x + 14,
            top: hover.y + 14,
            backgroundColor: 'rgba(0,0,0,0.8)',
            color: '#fff',
        }, children: hover.label }), document.body);
};
export const CoverageHoverTooltip = React.memo(CoverageHoverTooltipComponent);
